import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik, Form as FormikForm } from 'formik';
import * as Yup from 'yup';
import AdminInformationSection from './createAdminForm/AdminInformationSection';
import { updateAdministrator } from '../../api/Admin';
import { useState } from 'react';
import Spinner from 'react-bootstrap/esm/Spinner';

function UpdateAdminModal(props) {
  const {
    admin,
    setToastType,
    setToastTitle,
    setToastBody,
    setShowToast,
    ...rest
  } = props;
  const [updating, setUpdating] = useState(false);

  const administratorSchema = Yup.object().shape({
    firstName: Yup.string()
      .matches(/^[A-Öa-ö\-]*$/, 'Endast bokstäver tillåtet')
      .min(2, 'För kort förnamn')
      .max(20, 'För långt förnamn')
      .required('Du måste ange ett förnamn'),
    lastName: Yup.string()
      .matches(/^[A-Öa-ö\-]*$/, 'Endast bokstäver tillåtet')
      .min(2, 'För kort efternamn')
      .max(20, 'För långt efternamn')
      .required('Du måste ange ett efternamn'),
  });

  return (
    <Modal
      {...rest}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Redigera {admin?.firstName} {admin?.lastName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Redigera administratörskontot</p>

        <Formik
          initialValues={{
            adminId: admin?.id,
            firstName: admin?.firstName,
            lastName: admin?.lastName,
          }}
          onSubmit={async (values) => {
            setUpdating(true);
            const result = await updateAdministrator(values);
            if (result) {
              switch (result.statusCode) {
                case 200:
                  setToastType('success');
                  setToastTitle('Administratör uppdaterad');
                  setToastBody('Administratören har blivit uppdaterad');
                  break;
                default:
                  setToastType('danger');
                  setToastTitle('Administratör ej uppdaterad');
                  setToastBody('Administratören kunde inte uppdateras');
              }
              props.onHide();
              setShowToast(true);
              setUpdating(false);
            }
          }}
          validationSchema={administratorSchema}
          enableReinitialize={true}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <FormikForm
              id='form-update-administrator'
              noValidate
              onSubmit={handleSubmit}
            >
              <AdminInformationSection
                values={values}
                handleChange={handleChange}
                handleBlur={handleBlur}
                errors={errors}
                touched={touched}
                edit={true}
              />
            </FormikForm>
          )}
        </Formik>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => props.onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button type='submit' form='form-update-administrator'>
          {updating ? (
            <>
              <Spinner
                as='span'
                animation='border'
                size='sm'
                role='status'
                aria-hidden='true'
                className='me-2'
              />
              <span className='visually-hidden'>Loading...</span>
              Spara
            </>
          ) : (
            'Spara'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default UpdateAdminModal;
